var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreequartpizza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 612,
    viewBox: "0 0 750 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1739_1623)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-28.1847 368.154L196.822 52.1486L-178.681 96.006C-185.37 11.1798 -163.416 -76.3811 -110.201 -151.117C10.0857 -320.052 244.546 -359.488 413.48 -239.201C582.414 -118.914 621.85 115.546 501.563 284.48C381.276 453.414 146.816 492.85 -22.1178 372.564C-24.159 371.11 -26.1813 369.64 -28.1847 368.154Z",
    fill: "#CA793F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04441 320.081L196.822 52.1482L-120.504 89.2107C-125.811 18.0566 -107.255 -55.2593 -62.6644 -117.884C38.8827 -260.499 236.998 -293.662 379.838 -191.955C522.679 -90.2472 556.154 107.816 454.606 250.431C353.059 393.046 154.944 426.209 12.1036 324.502C10.0615 323.048 8.04175 321.574 6.04441 320.081Z",
    fill: "#FFD770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.632 352.257C133.105 355.418 122.622 380.485 87.6074 364.146C42.3737 355.262 93.5081 384.306 101.55 398.011C109.591 411.717 190.733 412.409 208.531 420.171C226.328 427.933 277.379 401.062 260.797 389.869C244.215 378.676 244.629 383.267 208.183 381.868C171.737 380.469 162.158 349.097 147.632 352.257Z",
    fill: "#CA793F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.351 289.213C391.036 300.92 395.026 309.899 366.731 333.331C331.227 362.734 372.896 359.405 388.597 361.852C404.298 364.299 456.183 301.909 473.456 293.041C490.729 284.173 502.229 227.639 483.069 233.395C463.908 239.151 476.026 226.066 451.879 253.4C427.732 280.735 423.667 277.506 407.351 289.213Z",
    fill: "#CA793F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.6,
    cy: 290.952,
    r: 36.5,
    transform: "rotate(-144.548 98.6 290.952)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.118,
    cy: 302.275,
    r: 36.5,
    transform: "rotate(-144.548 223.118 302.275)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.491,
    cy: 180.242,
    r: 36.5,
    transform: "rotate(-144.548 416.491 180.242)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.552,
    cy: 80.9293,
    r: 36.5,
    transform: "rotate(-144.548 457.552 80.9293)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.479,
    cy: 16.1314,
    r: 36.5,
    transform: "rotate(-144.548 386.479 16.1314)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.706,
    cy: -12.9448,
    r: 36.5,
    transform: "rotate(-144.548 288.706 -12.9448)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.996,
    cy: 106.327,
    r: 36.5,
    transform: "rotate(-144.548 342.996 106.327)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.16,
    cy: 254.234,
    r: 36.5,
    transform: "rotate(-144.548 321.16 254.234)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.931,
    cy: 4.815,
    r: 36.5,
    transform: "rotate(-144.548 132.931 4.815)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.877,
    cy: 185.102,
    r: 36.5,
    transform: "rotate(-144.548 231.877 185.102)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.811,
    cy: 77.9839,
    r: 36.5,
    transform: "rotate(-144.548 240.811 77.9839)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.739,
    cy: -33.9692,
    r: 36.5,
    transform: "rotate(-144.548 26.739 -33.9692)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.9425 335.124C-20.5953 341.116 -39.7489 359.395 -26.308 368.966L24.734 297.281C12.0595 307.898 -14.0202 330.33 -16.9425 335.124Z",
    fill: "#CA793F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9264 187.34L139.323 132.048C143.663 133.119 147.879 135.01 151.741 137.761C168.163 149.453 171.996 172.244 160.304 188.665C148.611 205.086 125.821 208.919 109.4 197.227C105.53 194.471 102.36 191.1 99.9264 187.34Z",
    fill: "#832120"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1739_1623",
    x: -183.849,
    y: -308.849,
    width: 759.059,
    height: 759.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1739_1623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1739_1623",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreequartpizza);
export default __webpack_public_path__ + "static/media/threequartpizza.26cfb13ca6df56ff88d9b642ed451e3f.svg";
export { ForwardRef as ReactComponent };